export const geographyQuestions = [
  {
    id: 'geography-001',
    category: 'Geography',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'What is the capital of Japan?',
    options: ['Tokyo', 'Kyoto', 'Osaka', 'Beijing'],
    answer: 'Tokyo',
    insight: 'Tokyo is Japan capital and largest metropolitan area.',
    tags: ['capitals', 'japan', 'asia'],
    points: 10,
  },
  {
    id: 'geography-002',
    category: 'Geography',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'Which ocean is the largest?',
    options: ['Pacific', 'Atlantic', 'Indian', 'Arctic'],
    answer: 'Pacific',
    insight: 'The Pacific Ocean covers more area than any other ocean.',
    tags: ['oceans', 'pacific', 'earth'],
    points: 10,
  },
  {
    id: 'geography-003',
    category: 'Geography',
    difficulty: 'Easy',
    type: 'true/false',
    question: 'Mount Everest is the tallest mountain above sea level.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Everest is about 8,849 meters above sea level.',
    tags: ['mountains', 'everest', 'asia'],
    points: 10,
  },
  {
    id: 'geography-004',
    category: 'Geography',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'What is the capital of Australia?',
    options: ['Canberra', 'Sydney', 'Melbourne', 'Perth'],
    answer: 'Canberra',
    insight: 'Canberra was chosen as a compromise capital.',
    tags: ['capitals', 'australia', 'cities'],
    points: 20,
  },
  {
    id: 'geography-005',
    category: 'Geography',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which country is known as the Land of the Rising Sun?',
    options: ['Japan', 'China', 'Thailand', 'South Korea'],
    answer: 'Japan',
    insight: 'Japan lies east of the Asian mainland.',
    tags: ['countries', 'japan', 'nicknames'],
    points: 20,
  },
  {
    id: 'geography-006',
    category: 'Geography',
    difficulty: 'Medium',
    type: 'true/false',
    question: 'The Sahara is the largest hot desert in the world.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'The Sahara is the largest hot desert on Earth.',
    tags: ['deserts', 'sahara', 'africa'],
    points: 20,
  },
  {
    id: 'geography-007',
    category: 'Geography',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which is the smallest country in the world by area?',
    options: ['Vatican City', 'Monaco', 'San Marino', 'Liechtenstein'],
    answer: 'Vatican City',
    insight: 'Vatican City is an independent city-state inside Rome.',
    tags: ['countries', 'vatican', 'europe'],
    points: 20,
  },
  {
    id: 'geography-008',
    category: 'Geography',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'Which river is commonly listed as the longest in the world?',
    options: ['Nile', 'Amazon', 'Yangtze', 'Mississippi'],
    answer: 'Nile',
    insight: 'The Nile is commonly listed as the longest river.',
    tags: ['rivers', 'nile', 'africa'],
    points: 30,
  },
  {
    id: 'geography-009',
    category: 'Geography',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'Which country has the most natural lakes?',
    options: ['Canada', 'Russia', 'Brazil', 'Norway'],
    answer: 'Canada',
    insight: 'Canada has more natural lakes than any other country.',
    tags: ['lakes', 'canada', 'water'],
    points: 30,
  },
  {
    id: 'geography-010',
    category: 'Geography',
    difficulty: 'Hard',
    type: 'true/false',
    question: 'The equator passes through Ecuador.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Ecuador is named for the equator.',
    tags: ['equator', 'ecuador', 'latitude'],
    points: 30,
  },
];
